import { useState, useEffect, useCallback } from 'react';

// Inspired by https://usehooks.com/
export const useAsync = <T, E = Error>(
  asyncFunction: () => Promise<T>
): [T | null | undefined, boolean, E | null | undefined] => {
  // Why store the value in an object? Because if T happens to be a function,
  // setValue will actually call the function because it thinks that's how it
  // should get the new value. Go on, ask me how I know.
  const [value, setValue] = useState<{ value: T } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<{ value: E } | null>(null);

  const execute = useCallback(() => {
    setValue(null);
    setLoading(true);
    setError(null);

    return asyncFunction()
      .then((result) => setValue({ value: result }))
      .catch((error: E) => setError({ value: error }))
      .finally(() => setLoading(false));
  }, [asyncFunction]);

  useEffect(() => {
    execute();
  }, [execute]);

  return [value?.value, loading, error?.value];
};
